import { PLAN_ASSESSED, STATS_UNLOADED } from './types'
import api from 'api'

export const planAssessed = data => ({
  type: PLAN_ASSESSED,
  data
})

export const statsUnload = () => ({
  type: STATS_UNLOADED
})

export const unloadStats = () => dispatch => {
  dispatch(statsUnload())
}

export const assessPlan = (planid, update) => dispatch =>
  api.bmc.stats.assessPlan(planid, update).then( data => {
    if (data) { data=JSON.parse(data) }
    dispatch(planAssessed(data))
  })
